// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffaf2718","952":"c45fbda2"}[chunkId] + ".chunk.js";
};